import {ItemGroup} from "./itemGroup";
import {GroupRepository} from './groupRepository';
import {XmlTagInfo} from '../xmlTagProvider'
import {Form} from '../form/form'
import {CellItem} from "../items/cellItem";

/**
 * RadioGroup can contain both RadioItem and LabelItem
 */
export class RadioGroup extends ItemGroup<CellItem> {

	cumulative: boolean;
	variable: string;
	virtualValue: any;

	constructor(config: XmlTagInfo, form: Form){
		super(config, form);
		this.variable = config.attributes['variable'];
		this.cumulative = config.attributes['cumulative'] === 'yes';
	}

	setVirtualValue(value: any) {
        this.virtualValue = value;
    }

    resetVirtualValue() {
	    this.virtualValue = undefined;
    }
}

// @ts-ignore
GroupRepository.register('radioGroup', RadioGroup);
